import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import MyModal from "../../components/MyModal";
import Firebase from "../../firebasehelper";

import "./index.css";

const UmbrellaChannel = () => {
  const location = useLocation();
  const history = useHistory();
  const umbrellaBrand = Number(localStorage.getItem("umbrella"));
  const [isLoading, setLoading] = useState(true);
  const [brand, setBrand] = useState({});
  const [brands, setBrands] = useState([]);
  const [totalBrands, setTotalBrands] = useState([]);
  const [username, setUserName] = useState("");
  const [role, setRole] = useState(0);
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      if (process.env.REACT_APP_USER !== "admin") history.push("/");
      const { role, username } = location.state;
      Firebase.getAllBrands((res) => {
        let brands = res
          .map((item, index) => {
            let new_item = item;
            new_item.id = index;
            return new_item;
          })
          .filter((item) => item.name);
        let subBrands = [];
        const parentBrand = brands.find(
          (obj) => obj && obj.id === umbrellaBrand
        );
        if (role === 2 || role === 10) {
          subBrands = brands.filter((obj) => obj.parent === umbrellaBrand);
        }
        setLoading(false);
        setBrand(parentBrand);
        setBrands(subBrands);
        setTotalBrands(brands);
        setUserName(username);
        setRole(role);
      });
    }
  }, [location]);

  const goBack = () => {
    history.goBack();
  };
  const showBrands = () => {
    let filteredBrands = [...brands];
    filteredBrands.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    filteredBrands = [brand, ...filteredBrands];
    return filteredBrands.map((item) => {
      const logo = item.logo;
      const brand = item.id;
      const icon = item.icon;
      const name = item.name;
      return (
        <div
          className="brand-item-container umbrella-item-container"
          key={item.id}
          style={{ display: "block" }}
        >
          <Link
            to={{
              pathname: "/analytics",
              state: {
                brand: brand,
                username: username,
                role: role,
              },
            }}
            className="brand-item-container"
          >
            <div
              className="logo-container"
              style={{ backgroundImage: `url(${icon})` }}
            ></div>
            <p>{name}</p>
          </Link>
        </div>
      );
    });
  };
  const addBrand = (
    brandName,
    brandUrl,
    logo_img,
    icon_img,
    hexcode,
    territory,
    umbrella
  ) => {
    const { role } = location.state;
    const umbrellaBrand = Number(localStorage.getItem("umbrella"));
    Firebase.addFiletoBrand(
      brandName,
      brandUrl,
      logo_img,
      icon_img,
      hexcode,
      territory,
      umbrella,
      (res) => {
        console.log("image url", res);
        if (res !== "error") {
          Firebase.createDefaultBrandAdmin(res, brandName);
          if (role !== 0 && umbrellaBrand) {
            Firebase.updateBrandDataById(res, { parent: umbrellaBrand });
          }
        }
      }
    );
  };
  return brand ? (
    <div id="page-container">
      <Header
        username={username}
        role={role}
        brand={brand.id}
        logo={brand && brand.logo}
        onHome={goBack}
      />
      <main id="umbrella-container" className="channel-container">
        <div className="content">
          {!isLoading ? (
            <React.Fragment>
              <div className="add-brand-filter-container">
                <button
                  type="button"
                  className="btn btn-primary post add-new-brand"
                  data-toggle="modal"
                  data-target="#add_brand"
                >
                  Add a new brand
                </button>
              </div>
              <div className="brands-container">
                <div
                  className="brand-items-container"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {showBrands()}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          )}
        </div>
        <MyModal
          addImage={addBrand}
          brands={totalBrands}
          isSuperAdmin={role === 0}
        />
      </main>
    </div>
  ) : null;
};
export default UmbrellaChannel;



// WEBPACK FOOTER //
// ./src/screens/UmbrellaChannel/index.js